import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class BankAccountService {
    constructor(private httpService: HttpService) {

    }

    owners(): Observable<any[]> {
        return this.httpService.get('/api/account/owners');
    }

    accounts(ownerId): Observable<any[]> {
        return this.httpService.get('/api/account/list', {
            ownerId: ownerId
        });
    }

    owner(id): Observable<any[]> {
        return this.httpService.get('/api/account/owner', {
            id: id
        });
    }

    account(id): Observable<any[]> {
        return this.httpService.get('/api/account/get', {
            id: id
        });
    }

    edit(account: any, code?: string): Observable<boolean> {
        let item = account;
        account.SmsCode = code;
        return this.httpService.post('/api/account/add', account);
    }

    editOwner(owner: any, code?: string): Observable<boolean> {
        let item = owner;
        item.SmsCode = code;
        return this.httpService.post('/api/account/edit-owner', item);
    }

    delete(id: any, code?: any): Observable<boolean> {
        let item = {
            id: id,
            SmsCode: code
        };
        return this.httpService.post('/api/account/delete', item);
    }

    deleteValidation(id: any): Observable<boolean> {
        return this.httpService.get('api/account/delete-validation', { id: id });
    }

    deleteOwner(id): Observable<boolean> {
        return this.httpService.post('/api/account/delete-owner', id);
    }

    getBankName(bankCountryId: any, iban: any) {
        return this.httpService.get('/api/account/get-bank-name', {
            bankCountryId: bankCountryId,
            iban: iban
        });
    }

    isSwiftVisible(bankCountryId: any, iban: any) {
        return this.httpService.get('/api/account/is-swift-visible', {
            bankCountryId: bankCountryId,
            iban: iban
        });
    }

    getSwift(bankCountryId: any, iban: any) {
        return this.httpService.get('/api/account/get-swift', {
            bankCountryId: bankCountryId,
            iban: iban
        });
    }

    getMatchingCantorBankId(bankCodeId: any) {
        return this.httpService.get('api/account/get-matching-cantor-bank-id', {
            bankCodeId: bankCodeId
        });
    }

    getCurrencies() {
        return this.httpService.get('api/account/get-currencies');
    }

    cantorBankGroups() {
        return this.httpService.get('/api/account/cantor-bank-groups');
    }

    bankCodesForCurrency(currencyId: any) {
        return this.httpService.get('/api/account/for-currency', {
            currencyId: currencyId
        });
    }

    isAccountActive() {
        return this.httpService.get('/api/account/is-active');
    }

    isAccountReadyForReacharge() {
        return this.httpService.get('api/account/is-ready-for-recharge');
    }

    isAccountReadyForExchange() {
        return this.httpService.get('api/account/is-ready-for-exchange');
    }

    isAccountReadyForWithdrawal() {
        return this.httpService.get('api/account/is-ready-for-withdrawal');
    }

    isAccountBankCodeChangeLocked() {
        return this.httpService.get('api/account/is-changing-owner-locked');
    }

    isSmsNeededForNewAccount(account) {
        return this.httpService.post('api/account/is-sms-needed-for-new-account', account);
    }

    isSwiftCorrect(account) {
        return this.httpService.post('api/account/is-swift-correct', account);
    }

    getImageAndUrlByName(name) {
        return this.httpService.get('/api/account/get-bank-logo-and-url', {
            bankName: name
        });

        //return result;
    }
}
